import { useQuery } from '@tanstack/react-query';

import { OTAService } from '../services';

export const useOTAgroupHistory = (groupId: number) => {
  const queryKey = ['otaGroupHistory', groupId];

  const queryFn = () => OTAService.getHistory(groupId);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!groupId,
    staleTime: 0,
  });
};
